import React from 'react';
import { GeoJSON } from 'react-leaflet';

export default function VtGeo(props) {
  const { mapStyle, geo } = props;

  return (
    <GeoJSON
      data={geo}
      style={mapStyle}
    /> 
  )
}
